import fetch from 'node-fetch';
import { createConfig } from '../../config';
import type { GetNavigationParams } from '../types';

type NavigationResponse = Record<string, unknown>;

export const getNavigation = async ({
  id,
  depth = 3,
  subset = 'MOBILE_WEB,FLYOUT',
  queryParams = '',
  exp = '',
}: GetNavigationParams = {}): Promise<
  NavigationResponse | { error: NavigationResponse }
> => {
  const { urls } = createConfig();
  const idUrl = id ? `/${id}` : '';
  let params = queryParams ? `${queryParams.replace(/^\?/, '')}&` : '';
  params += `depth=${depth}&subset=${subset}`;
  if (exp) {
    params += `&experiments=${encodeURIComponent(exp)}`;
  }
  const uri = `${urls.base}/header/api/navigation${idUrl}?${params}`;
  const res = await fetch(uri, { credentials: 'include' });
  const json = (await res.json()) as NavigationResponse;

  if (res.status !== 200) {
    return { error: json };
  }
  return json;
};
